function partialMatch(value) {
  return value?.toString()?.split(" ").join("").concat("*");
}
function partialMatchWithSpecialSymbols(value) {
  function hasSpecialSymbol(text) {
    return text?.match(/[#@&<>~.?+\-_*|{}[\]()"\\]/i);
  }
  function formatSpecialSymbols(text) {
    return text?.toString()?.split(/(?=[#@&<>~.?+\-_*|{}[\]()"\\])/).join("\\");
  }
  return hasSpecialSymbol(value) ? formatSpecialSymbols(value) : partialMatch(value);
}
export {
  partialMatch,
  partialMatchWithSpecialSymbols
};
//# sourceMappingURL=elasticSearch.js.map
